export default class GetMassProductsRequest {
    public showDeleted: boolean = false;

    public excludeUnMapped: boolean = false;
}